import React from 'react';

export const TargetApp = React.createContext({
    config: null,
    get: () => {},
    request: null
})
